export const dateFormat = (dateString: string, format = 'dd MMM yyyy') => {
    let date = new Date(dateString);

    // Handle non-ISO format like "19/05/2025 03:52 AM"
    if (isNaN(date.getTime()) && /^\d{2}\/\d{2}\/\d{4}/.test(dateString)) {
        const [datePart, timePart, meridian] = dateString.split(' ');
        const [day, month, year] = datePart.split('/');
        let hours = 0, minutes = 0;

        if (timePart && meridian) {
            [hours, minutes] = timePart.split(':').map(Number);
            if (meridian.toLowerCase() === 'pm' && hours < 12) hours += 12;
            if (meridian.toLowerCase() === 'am' && hours === 12) hours = 0;
        }

        date = new Date(Number(year), Number(month) - 1, Number(day), hours, minutes);
    }
    if (isNaN(date.getTime()) && /^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
        const [day, month, year] = dateString.split('-');
        date = new Date(Number(year), Number(month) - 1, Number(day));
    }

    // If still invalid, return fallback message
    if (isNaN(date.getTime())) return "Invalid Date";

    // Adjust timezone
    const offsetMinutes = date.getTimezoneOffset();
    date.setMinutes(date.getMinutes() - offsetMinutes);

    // Month labels
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    // Format the date
    switch (format) {
        case "dd MMM yyyy":
            return `${padZero(date.getDate())} ${months[date.getMonth()]} ${date.getFullYear()}`;
        case "dd/MM/yy":
            return `${padZero(date.getDate())}/${padZero(date.getMonth() + 1)}/${String(date.getFullYear()).slice(-2)}`;
        case "dd-MM-yyyy":
            return `${padZero(date.getDate())}-${padZero(date.getMonth() + 1)}-${date.getFullYear()}`;
        case "dd/MM/yyyy":
            return `${padZero(date.getDate())}/${padZero(date.getMonth() + 1)}/${date.getFullYear()}`;
        default:
            return "Invalid format";
    }
};

// Pad helper
function padZero(num: number) {
    return (num < 10 ? '0' : '') + num;
}
export const statusColor = (status: string) => {
    const color = status?.toLowerCase()?.split(" ")?.join("_")
    const colors: any = {
        "backorder": "!bg-[#F3EDE9]",
        "open_order": "!bg-[#F3EDE9]",
        "delivered": "!bg-[#CCECE8]",
        "invoiced": "!bg-[#F3EDE9]",
        "cancelled": "!bg-[#FFC8C8]",
        "none": "!bg-[#E5E9EB]",
        "partially_delivered": "!bg-[#F3EDE9]",
        "not_available": "!bg-[#E5E9EB]"
    }
    return colors[color] ?? "!bg-[#F3EDE9]";
}